export function sortByString<T>(items: T[], getSortBy: (item: T) => string) {
  return items.sort((a, b) =>
    getSortBy(a) > getSortBy(b) ? 1 : getSortBy(b) > getSortBy(a) ? -1 : 0
  );
}
